import { TSelect } from '@variantjs/vue';

const styles = [
    'text-neutral.low_dark.DEFAULT',
    'text-base',
    'placeholder-neutral.low_dark.3',
    'bg-white border-gray-300 ',
    'focus:border-brand-primary_pure',
    'lock',
    'w-full',
    'pl-3',
    'pr-10',
    'py-2',
    'transition',
    'duration-100',
    'ease-in-out',
    'border',
    'rounded',
    'shadow-sm',
    'focus:ring-1',
    'focus:ring-brand-primary_pure',
    'focus:outline-none',
    'disabled:opacity-50',
    'disabled:cursor-not-allowed',
    'h-50px',
];

const settings = {
    TSelect: {
        component: TSelect,
        props: {
            classes: styles,
        },
    },
};

export default settings;
